import React, { createContext, useContext } from 'react';
import { WorkspaceScope } from '../../types/workspace';

const WorkspaceContext = createContext<WorkspaceScope | null>(null);

export function WorkspaceProvider({ scope, children }: { scope: WorkspaceScope; children: React.ReactNode }) {
  return <WorkspaceContext.Provider value={scope}>{children}</WorkspaceContext.Provider>;
}

export function useWorkspace(): WorkspaceScope {
  const scope = useContext(WorkspaceContext);
  if (!scope) throw new Error('Workspace가 확인되지 않았습니다. 다시 로그인해주세요.');
  return scope;
}
